import script from './component-lib.esm95.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Square'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M5.347 0c-2.953 0-5.347 2.394-5.347 5.347v0 21.307c0 2.947 2.4 5.333 5.347 5.347h21.307c2.947 0 5.347-2.4 5.347-5.347v-21.32c-0.008-2.947-2.398-5.333-5.347-5.333 0 0 0 0-0 0v0zM7.507 5.813h16.987c0.933 0 1.68 0.76 1.68 1.693v16.987c0 0.933-0.747 1.693-1.68 1.693h-16.987c-0.933 0-1.68-0.76-1.68-1.693v-16.987c0 0 0-0 0-0 0-0.931 0.751-1.686 1.679-1.693h0.001zM12.613 11.613c-0.538 0-0.973 0.436-0.973 0.973v0 6.787c0 0.533 0.427 0.96 0.96 0.96h6.8c0 0 0 0 0 0 0.533 0 0.966-0.428 0.973-0.959v-6.787c0-0.538-0.436-0.973-0.973-0.973v0z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var SquareIcon = __vue_component__;
export { SquareIcon as default };